<template>
  <el-dialog
    title="选择视频"
    :visible.sync="videoVisible"
    :close-on-click-modal="false"
    :before-close="cancelAction"
    width="920px"
    append-to-body
  >
    <div>
      <el-upload
        class="upload"
        :multiple="true"
        action=""
        accept="video/mp4"
        :show-file-list="false"
        :data="localpostData"
        :http-request="handleUpload"
        :before-upload="beforeAvatarUpload"
        :on-success="handleAvatarSuccess"
        :on-error="uploadError"
      >
        <el-button
          size="small"
          type="primary"
        >
          上传视频
        </el-button>
      </el-upload>
      <div
        v-loading="loading"
        class="video-list"
      >
        <div
          v-for="(item, index) in videoList"
          :key="item.id"
          class="video-item"
          @click="checkedImg(item, index)"
        >
          <div class="video-img">
            <video
              class="video"
              controls="controls"
              :src="item.image_url"
            />

            <!-- 遮罩 -->
            <!-- <div class="play_mask">
              <div class="play_mask_inner">
                <div class="play_mask_icon el-icon-video-play"></div>
              </div>
            </div> -->
          </div>
          <div class="video-detail">
            <div class="video-name">
              {{ item.image_name }}
            </div>
            <div class="video-select">
              <i
                v-if="item.selected"
                class="el-icon-success video-selected"
              />
              <i
                v-else
                class="el-icon-success"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer select-footer"
    >
      <div>
        <el-pagination
          layout="total, prev, pager, next, jumper"
          :current-page="params.page"
          :total="total_count"
          :page-size="params.page_size"
          @current-change="handleCurrentChange"
        />
      </div>
      <div>
        <span class="m-r-6">已选中{{ localcheckedItem.length }}个视频</span>
        <el-button
          type="primary"
          @click="saveImageAction"
        >
          确定
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getImageList, uploadImage } from '@/api/component'
import UploadUtil from '../../utils/uploadUtil'
export default {
  name: 'SpVideoSelect',
  model: {
    prop: 'videoVisible',
    event: 'videoVisibleChange'
  },
  props: {
    videoVisible: {
      // 展示选择视频的模态框
      type: Boolean,
      default: false
    },
    chooseOne: {
      // 只可选择一个
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      total_count: 0,
      params: {
        page: 1,
        page_size: 20,
        storage: 'videos'
      },
      videoList: [],
      localpostData: {
        token: '',
        key: '',
        fname: ''
      },
      localcheckedItem: []
    }
  },
  computed: {},
  watch: {
    videoVisible (newVal, oldVal) {
      console.log(newVal, 'newValnewValnewValnewValnewVal')
      if (newVal) {
        this.localcheckedItem = []
        this.getVideoList()
      }
    }
  },
  methods: {
    // 选择视频
    checkedImg (item, index) {
      if (this.chooseOne) {
        // 视频单选
        this.videoList.map((v) => (v.selected = false))
        item.selected = true
        this.localcheckedItem = this.videoList.filter((v) => v.image_id === item.image_id)
      } else {
        // 视频多选
        item.selected = !item.selected
        if (item.selected) {
          this.localcheckedItem.push(item)
        } else {
          this.localcheckedItem = this.localcheckedItem.filter((v) => v.image_id !== item.image_id)
        }
      }
    },

    // 分页器页面切换
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getVideoList()
    },

    // 关闭模态框
    cancelAction () {
      this.$emit('videoVisibleChange', false)
    },
    // 保存绑定
    saveImageAction () {
      this.$emit('chooseVideo', this.localcheckedItem)
    },
    // 获取视频列表
    async getVideoList () {
      this.loading = true
      const data = await getImageList(this.params)
      if (data) {
        data.list.forEach((v) => {
          v.selected = false
          this.localcheckedItem.forEach((item) => {
            if (item.selected && item.image_id === v.image_id) {
              v.selected = true
            }
          })
        })

        this.videoList = data.list
        this.total_count = data.total_count
        this.loading = false
      }
    },
    // 自定义上传
    handleUpload: function (e) {
      const upload = new UploadUtil('videos')
      // 上传
      upload
        .uploadImg(e.file, e.file.name)
        .then(
          (res) => e.onSuccess(res),
          (err) => e.onError(err)
        )
        .catch((err) => e.onError(err))
    },
    // 上传错误回调
    uploadError: function (e) {
      this.$message.error(e)
    },
    beforeAvatarUpload (file) {
      const isVideo = file.type === 'video/mp4'
      const isLt2M = file.size / 1024 / 1024 < 10

      if (!isVideo) {
        this.$message.error('上传视频只能是 MP4 格式!')
        return
      }
      // if (!isLt2M) {
      //   this.$message.error('上传视频大小不能超过 10MB!')
      //   return
      // }

      this.localpostData.fname = file.name
    },
    async handleAvatarSuccess (res, file) {
      let name = file.name.substring(0, file.name.lastIndexOf('.'))
      let uploadParams = {
        image_name: name, //视频名称必填,不能超过50个字符
        image_url: res.key, //视频链接必填
        image_type: file.raw.type, //视频分类长度不能超过20个字符
        storage: 'videos' //视频id必填
      }
      const data = await uploadImage(uploadParams)
      if (data) {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        this.getVideoList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.select-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.video-list {
  display: flex;
  flex-wrap: wrap;
  margin: 20px -10px 0;

  .video-item {
    width: 160px;
    height: 122px;
    margin: 0 10px 20px;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
    overflow: hidden;

    .video-img {
      width: 100%;
      height: 90px;
      position: relative;
      &:hover {
        .play_mask {
          display: block;
        }
      }
      .video {
        display: block;
        width: 100%;
        height: 100%;
      }

      .play_mask {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        display: none;
        .play_mask_inner {
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          .play_mask_icon {
            color: #fff;
            font-size: 32px;
          }
        }
      }
    }

    .video-detail {
      height: 32px;
      padding: 0 6px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;

      .video-name {
        width: 100px;
        padding: 0 6px;
        color: #606266;
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .video-select {
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        i {
          font-size: 18px;
          color: #ccc;
        }
        .video-selected {
          color: #1480e3;
        }
      }
    }
  }
}
</style>
